import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FetchStateType } from "../../models";
import { MonthlyTradingReportData } from "./types";

type MonthlyTradesReportData = {
  data?: MonthlyTradingReportData[];
  downloadReportFetchState: FetchStateType;
};

const initialState: MonthlyTradesReportData = {
  downloadReportFetchState: { type: "not-started" },
};

const name = "monthlyTrade";

const monthlyTradeSlice = createSlice({
  name,
  initialState,
  reducers: {
    setData: (
      state,
      action: PayloadAction<MonthlyTradingReportData[] | undefined>
    ) => ({
      ...state,
      data: action.payload,
    }),
    setFetchState: (state, action: PayloadAction<FetchStateType>) => ({
      ...state,
      downloadReportFetchState: action.payload,
    }),
  },
});

export const { setData, setFetchState } = monthlyTradeSlice.actions;

export default monthlyTradeSlice.reducer;
